/**
 *
 * Multi Select Field
 *
 */

import React from "react"
import PropTypes from "prop-types"
// import makeAnimated from "react-select/animated"
import { Label, FormGroup } from "reactstrap"
import { default as ReactSelect, components } from "react-select"

function SelectAllField(props) {
  const {
    label,
    name,
    value,
    onChange,
    isInvalid,
    metaData,
    required,
    options = [],
    // allOption,
  } = props
  const selectOptions =
    options && Array.isArray(options)
      ? options
      : typeof options === "string" &&
        metaData &&
        metaData[options] &&
        metaData[options].length > 0
      ? metaData[options]
      : []
  const menuPortalTarget = document.getElementById("root")

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            // value={props.value}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    )
  }
  const allOption = {
    label: "Select all",
    value: "*",
  }
  const MySelect = (props) => {
    if (props.allowSelectAll) {
      return (
        <ReactSelect
          {...props}
          options={[allOption, ...props.options]}
          onChange={(selected, event) => {
            if (selected !== null && selected.length > 0) {
              if (selected[selected.length - 1].value === allOption.value) {
                return onChange([allOption, ...props.options])
              }
              let result = []
              if (selected.length === props.options.length) {
                if (selected.includes(allOption)) {
                  result = selected.filter(
                    (option) => option.value !== allOption.value
                  )
                } else if (event.action === "select-option") {
                  result = [allOption, ...props.options]
                }
                return onChange(result)
              }
            }

            return onChange(selected)
          }}
        />
      )
    }

    return <ReactSelect {...props} />
  }

  const MultiValue = (props) => {
    let labelToBeDisplayed = `${props.label},`
    if (props.value === allOption.value) {
      labelToBeDisplayed = "All is selected"
    }
    return (
      <components.MultiValue {...props}>
        <span>{labelToBeDisplayed}</span>
      </components.MultiValue>
    )
  }
  // const MultiValue = props => (
  //   <components.MultiValue {...props}>
  //     <span>{props.label}</span>
  //   </components.MultiValue>
  // )
  // const animatedComponents = makeAnimated()
  // const [state, setState] = useState({
  //   optionSelected: null,
  // })

  // const handleChange = (selected) => {
  //   setState({
  //     optionSelected: selected,
  //   })
  // }
  return (
    <React.Fragment>
      <FormGroup className="no-margin">
        <Label htmlFor="formrow-firstname-Input">
          {label}
          {required ? (
            <span style={{ color: "red", marginLeft: "3px" }}>*</span>
          ) : null}
        </Label>
        <MySelect
          name={name}
          value={value}
          onChange={onChange}
          options={selectOptions}
          className={isInvalid ? "" : null}
          classNamePrefix="select2-selection"
          invalid={isInvalid ? true : false}
          
          isMulti={true}
          components={{
            Option,
            MultiValue,
          }}
          allowSelectAll={true}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuPortalTarget={menuPortalTarget}
        />
      </FormGroup>
    </React.Fragment>
  )
}

SelectAllField.propTypes = {
  t: PropTypes.any,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isSelected: PropTypes.func,
  placeholder: PropTypes.string,
  isInvalid: PropTypes.any,
  metaData: PropTypes.object,
  required: PropTypes.any,
  options: PropTypes.array,
  value: PropTypes.any,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}

SelectAllField.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
}

export default SelectAllField
